import { useState } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function UnifiedLogin() {
  const [loginType, setLoginType] = useState('admin')
  const [form, setForm] = useState({ username: '', phone: '', password: '' })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleLogin = async () => {
    setError('')
    
    const loginData = {
      phone: loginType === 'admin' ? form.username : form.phone,
      role: loginType === 'admin' ? 'admin' : loginType === 'base' ? 'base' : loginType === 'partner' ? 'partner' : 'agent'
    }
    
    if (loginType === 'admin') {
      if (!form.username || !form.password) {
        setError('请输入用户名和密码')
        return
      }
      loginData.password = form.password
    } else {
      if (!form.phone || !form.password) {
        setError('请输入手机号和密码')
        return
      }
      loginData.password = form.password
    }
    
    setLoading(true)
    try {
      // 使用统一登录API
      const res = await fetch(`${API}/auth/unified-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginData)
      })
      const data = await res.json()
      
      if (data.success) {
        const { id, name, role, token } = data.data
        
        // 先保存基础用户信息
        const userInfo = {
          id,
          name: name || loginData.phone,
          phone: loginData.phone,
          role,
          token
        }
        
        // 获取套餐信息（plan字段），非admin角色需要（3秒超时，不阻塞登录）
        if (role !== 'admin') {
          try {
            const controller = new AbortController()
            const timeout = setTimeout(() => controller.abort(), 3000)
            const planRes = await fetch(`${API}/plan/me`, {
              headers: { 'Authorization': 'Bearer ' + token },
              signal: controller.signal
            })
            clearTimeout(timeout)
            const planData = await planRes.json()
            if (planData.success && planData.user) {
              userInfo.plan = planData.user.plan || 'free'
              userInfo.institutionId = planData.user.institutionId
              userInfo.institutionName = planData.user.institutionName
              userInfo.planExpireAt = planData.user.planExpireAt
            }
          } catch(e) {
            console.warn('获取套餐信息失败（超时或网络错误）:', e.message || e)
          }
        }
        
        localStorage.setItem('cms_token', token)
        // 保存完整用户信息（含plan）
        localStorage.setItem('cms_user', JSON.stringify(userInfo))
        // 额外存 institutionId 到独立key，供PartnerStore等组件使用
        if (userInfo.institutionId) {
          localStorage.setItem('cms_institution_id', userInfo.institutionId)
        }
        
        // 根据角色跳转
        if (role === 'admin') {
          window.location.reload()
        } else if (role === 'base') {
          localStorage.setItem('base_token', token)
          localStorage.setItem('base_id', id)
          window.dispatchEvent(new CustomEvent('navigate', { detail: 'base-dashboard' }))
          window.location.reload()
        } else {
          window.location.reload()
        }
      } else {
        setError(data.error || '登录失败')
      }
    } catch (e) {
      setError('网络错误，请稍后重试')
    } finally {
      setLoading(false)
    }
  }

  const loginTypes = [
    { key: 'admin', label: '🏢 总部管理', desc: '管理员登录' },
    { key: 'base', label: '🏕️ 基地管理', desc: '研学基地登录' },
    
    { key: 'partner', label: '🤝 推广员', desc: '合伙人/推广员登录' },
    { key: 'agent', label: '🗺️ 区域代理', desc: '区域代理商登录' },
  ]

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: 420, boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🎋</div>
          <h2 style={{ margin: '0 0 4px', fontSize: 22 }}>博小兔企业大脑 · 管理系统</h2>
          <p style={{ margin: 0, color: '#999', fontSize: 13 }}>请选择登录身份</p>
        </div>

        {/* 登录类型选择 */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 20 }}>
          {loginTypes.map(t => (
            <div
              key={t.key}
              onClick={() => { setLoginType(t.key); setError(''); setForm({ username: '', phone: '', password: '' }); }}
              style={{
                padding: '12px 8px',
                borderRadius: 8,
                cursor: 'pointer',
                textAlign: 'center',
                fontSize: 13,
                background: loginType === t.key ? '#667eea' : '#f5f5f5',
                color: loginType === t.key ? '#fff' : '#666',
                border: loginType === t.key ? '2px solid #667eea' : '2px solid transparent',
                transition: 'all 0.2s'
              }}
            >
              <div style={{ fontWeight: 600, fontSize: 14 }}>{t.label}</div>
              <div style={{ fontSize: 11, opacity: 0.8 }}>{t.desc}</div>
            </div>
          ))}
        </div>

        {error && (
          <div style={{ background: '#fff2f0', border: '1px solid #ffccc7', color: '#ff4d4f', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 13, textAlign: 'center' }}>
            {error}
          </div>
        )}

        {loginType === 'admin' ? (
          <>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>用户名</label>
              <input
                type="text"
                value={form.username}
                onChange={e => setForm({...form, username: e.target.value})}
                onKeyDown={e => e.key === 'Enter' && handleLogin()}
                placeholder="请输入用户名"
                style={{ width: '100%', padding: '12px 14px', border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>密码</label>
              <input
                type="password"
                value={form.password}
                onChange={e => setForm({...form, password: e.target.value})}
                onKeyDown={e => e.key === 'Enter' && handleLogin()}
                placeholder="请输入密码"
                style={{ width: '100%', padding: '12px 14px', border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
              />
            </div>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>手机号</label>
              <input
                type="tel"
                value={form.phone}
                onChange={e => setForm({...form, phone: e.target.value})}
                onKeyDown={e => e.key === 'Enter' && handleLogin()}
                placeholder="请输入注册手机号"
                maxLength={11}
                style={{ width: '100%', padding: '12px 14px', border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }}>密码</label>
              <input
                type="password"
                value={form.password}
                onChange={e => setForm({...form, password: e.target.value})}
                onKeyDown={e => e.key === 'Enter' && handleLogin()}
                placeholder="请输入密码"
                style={{ width: '100%', padding: '12px 14px', border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
              />
            </div>
          </>
        )}

        <button
          onClick={handleLogin}
          disabled={loading}
          style={{ width: '100%', padding: '14px', background: loading ? '#d9d9d9' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer' }}
        >
          {loading ? '登录中...' : '登录'}
        </button>

        <div style={{ marginTop: 20, textAlign: 'center', fontSize: 12, color: '#999' }}>
          <span>还没有账号？</span>
          {loginType === 'base' && (
            <a href="/cms/?page=base-register" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 600 }}> 立即申请基地 →</a>
          )}
          {loginType === 'partner' && (
            <a href="/cms/?page=partner-register" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 600 }}> 立即申请推广员 →</a>
          )}
                    {loginType === 'agent' && (
            <a href="/cms/?page=regional-agent-register" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 600 }}> 立即申请区域代理 →</a>
          )}
        </div>

        {/* 协议与隐私(2026-09-17 审核合规) */}
        <div style={{ marginTop: 16, textAlign: 'center', fontSize: 12 }}>
          <a href="https://api.boxiaotu.cn/uploads/user-agreement.html" style={{ color: '#999', textDecoration: 'none' }}>《用户服务协议》</a>
          <span style={{ margin: '0 6px', color: '#ccc' }}>·</span>
          <a href="https://api.boxiaotu.cn/uploads/privacy-policy.html" style={{ color: '#999', textDecoration: 'none' }}>《隐私政策》</a>
        </div>
      </div>
    </div>
  )
}
